import { render } from "./TeamCalendar.vue?vue&type=template&id=8e4f4120"
import script from "./TeamCalendar.vue?vue&type=script&lang=js"
export * from "./TeamCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__